export default __webpack_public_path__ + "static/logo-cybertruck-bb96d3be959b28311dda7f66f03851c6.svg";